import styled from 'styled-components';

export const Wrapper = styled.div`
width: 100%;
box-sizing: border-box;
`;

export const Container = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: column wrap;
align-items: flex-start;
justify-content: flex-start;
`;

export const ModalWrapper = styled.div`
// width:100%;
padding:20px 50px 10px 50px;
`
export const ModalImg = styled.div`

`
export const ModalMessege = styled.h2`

`
export const ModalData = styled.h2`
width:100%;
padding:0 50px 0 50px;
`
export const UserBalance = styled.h4`

`
export const ModalAction = styled.h2`
 display:flex;
 justify-content:flex-end;
 gap:5px;
`
export const ModalFrom = styled.div`
    margin:10px;
`

export const ModalBtn = styled.div`
justify-content:flex-end;
display:flex;
gap:10px;
`
export const InputSection = styled.div`
display:flex;
gap:10px;
`